import React, { createContext, PureComponent } from 'react';
import { ISaferPayScriptContext } from '../types/SaferPayScriptContext';
import { IWorldlineConfiguration } from '../types/Payment';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  isSaferPayFieldsScriptLoad: false,
  worldlineConfiguration: undefined,
  saferPayToken: undefined,
  saferpayFields: {},
};

export const SaferPayScriptContext = createContext<Partial<ISaferPayScriptContext>>(initialValue);

export class SaferPayScriptContextProvider extends PureComponent<IProps, Partial<ISaferPayScriptContext>> {
  constructor(props) {
    super(props);
    this.state = {
      saferPayFields: {},
      isSaferPayFieldsScriptLoad: false,
      worldlineConfiguration: undefined,
      saferPayToken: undefined,
    };
  }

  setSaferPayScriptLoad = (isSaferPayScriptLoad: boolean) => {
    this.setState({ isSaferPayFieldsScriptLoad: isSaferPayScriptLoad });
  };

  setSaferPayScriptLoadAndConfig = (isSaferPayScriptLoad: boolean, worldlineConfiguration: IWorldlineConfiguration) => {
    this.setState({ isSaferPayFieldsScriptLoad: isSaferPayScriptLoad, worldlineConfiguration });
  };

  setSaferPayFields = (saferpayFields: Record<string, unknown>) => {
    this.setState({ saferPayFields: saferpayFields });
  };

  setSaferPayToken = (token: string | undefined) => {
    this.setState({ saferPayToken: token });
  };

  render() {
    const { Provider } = SaferPayScriptContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setSaferPayFieldsScriptLoad: this.setSaferPayScriptLoad,
          setSaferPayScriptLoadAndConfig: this.setSaferPayScriptLoadAndConfig,
          setSaferPayFields: this.setSaferPayFields,
          setSaferPayToken: this.setSaferPayToken,
        }}
      >
        {children}
      </Provider>
    );
  }
}
